import { navigate } from 'gatsby';

export const onRouteUpdate = ({ location }: { location: Location }) => {
  if (location.pathname != '/' && location.pathname.length > 1) {
    const pathname = location.pathname;

    const channel = pathname.split('/')[1];

    if (channel) {
      sessionStorage.setItem('channel', channel);
      localStorage.setItem('channel', channel);
      console.log('Channel:' + channel);
    }

    navigate('/' + location.search);
  }
}